import Api from 'services/apiService.js';
import { GET_RESULT, CREATE_RESULT, GET_RESULT_USER } from 'actionTypes';

function getResultUserEndpoint({ resultUUID }) {
  return `pse/result/${resultUUID}/user`;
}

export default {
  [GET_RESULT]: {
    endpoint: 'pse/result',
    apiFunc: Api.get,
  },
  [CREATE_RESULT]: {
    endpoint: 'pse/result',
    apiFunc: Api.post,
  },
  [GET_RESULT_USER]: {
    endpoint: getResultUserEndpoint,
    apiFunc: Api.get,
  },
};



// WEBPACK FOOTER //
// ./src/endpoints/resultEndpoints.js